(() => {
  'use strict';
  document.querySelectorAll('.venue-cover-photo').forEach(img => {
    const fallback=()=>{img.hidden=true;img.parentElement.classList.add('photo-unavailable');};
    img.addEventListener('error',fallback,{once:true});
    if(img.complete&&!img.naturalWidth)fallback();
  });
  const root=document.getElementById('plans-map');
  if(!root)return;
  const config=JSON.parse(document.getElementById('plans-data').textContent);
  const id=document.querySelector('script[data-detail-id]').dataset.detailId;
  const place=config.places.find(p=>p.id===id);
  if(!place?.geo)return;
  const script=src=>new Promise((resolve,reject)=>{const s=document.createElement('script');s.src=src;s.onload=resolve;s.onerror=reject;document.head.append(s);});
  const load=async()=>{
    const css=document.createElement('link');css.rel='stylesheet';css.href=config.prefix+'assets/vendor/maplibre-gl.css';document.head.append(css);
    try {
      await script(config.prefix+'assets/vendor/maplibre-gl.js');
      await script(config.prefix+'assets/planes-map.js?v='+encodeURIComponent(config.assetVersion));
      window.createTurronMap({places:[place],prefix:config.prefix,style:config.mapStyle,onArea:()=>{}});
    } catch {document.querySelector('#map-loading small').textContent='Puedes abrir la ubicación con el enlace de Google Maps.';}
  };
  const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();load();}},{rootMargin:'240px'});
  observer.observe(root);
})();
